module.exports = __webpack_public_path__ + "static/media/pianoPic.e6e4ec9b.jpg";